import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

export class BaseService {
    public serverUrl = environment.apiUrl;
    constructor() {

    }
    public createRequestHeader(contentType: string = null) {
        const headers = new HttpHeaders({
            // "AuthKey": "my-key",
            // "AuthToken": "my-token",
            'Accept-Language': this.getLang(),
            'Content-Type': contentType ? contentType : 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Set-Cookie': 'HttpOnly;Secure;SameSite=Strict'
        });

        return headers;
    }
    private getLang(): string {
        let lang = sessionStorage.getItem('lang');
        if (!lang) {
          lang = 'pl-PL';
        }
        return lang;
    }
}